// ⬡B:msria-home.cara_portal:SURFACE:legacy_three_panel_cara_chat:20260613⬡
// CaraPortal - the legacy CARA chat portal, full three-panel experience.
// Composes the shared ccwa-core surfaces, nothing rebuilt here:
//   LEFT   chat (CARA) iMessage style, work streams in like typing
//   CENTER voice (AURA) her living-particle interface, push to talk
//   RIGHT  widgets (WidgetRail)
// Thin frontend per the 90/10 law: it composes shared components and passes the
// resolved HAM down. CARA streams to AIR on the cara channel. Zero strings
// assembled here, zero business logic, no hardcoded person.
// Legacy hot-fix that retires when the real VESSEL is built.
import React, { useState } from 'react';
import { useHam } from '@aba/ham-core';
import { ThreePanelLayout, CARA, AURA, WidgetRail, LumaWidget } from '@aba/ccwa-core';
import { useNavigate } from 'react-router-dom';

export default function CaraPortal() {
  const { ham, loading } = useHam();
  const nav = useNavigate();
  const [voiceState, setVoiceState] = useState('idle');

  if (loading) return null;
  if (!ham) {
    nav('/meet');
    return null;
  }

  const userId = ham.acl_uid || ham.ham_uid;

  // LEFT: the CARA chat module, inline so it fills the panel
  const left = (
    <CARA
      appScope="msria"
      userId={userId}
      channel="cara"
      placement="inline"
    />
  );

  // CENTER: VARA voice, the living-particle interface, push to talk
  const center = (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <AURA
        state={voiceState}
        size={240}
        label="Tap to talk"
        onTap={() => setVoiceState(voiceState === 'idle' ? 'listening' : 'idle')}
      />
    </div>
  );

  // RIGHT: the widget rail with the real LUMA turn-explanation widget.
  // LumaWidget renders its own living welcome card until turns stream in.
  const widgets = [
    { id: 'luma', title: 'LUMA', element: <LumaWidget entries={[]} /> }
  ];
  const right = <WidgetRail widgets={widgets} />;

  return (
    <ThreePanelLayout
      leftPanel={left}
      centerPanel={center}
      rightPanel={right}
      glowing={voiceState === 'speaking'}
    />
  );
}
